import { Schema, z } from 'zod';
import { Appearance, AppearanceSchema } from '../commons';

/**
 * Common properties of module definition configs
 * @typedef BaseFieldDefinition
 * @property  - name : name of the field
 * @property  - label : a human readable name used in the management tool as a label for the field.
 * @property  - description : used in the management tool to provide guidance to editors.
 * @property  - appearance : used in the management tool to alter the editing experience.
 * @property  - validations : an optional object for defining rules about how a module definition can be instantiated.
 */
export type BaseFieldDefinition = {
  name: string;
  label: string;
  description?: string;
  appearance?: Appearance;
  validations?: {
    isRequired?: boolean;
  };
};

export const BaseFieldDefinitionSchema: Schema<BaseFieldDefinition> = z.object({
  name: z.string(),
  label: z.string(),
  description: z.string().optional(),
  appearance: AppearanceSchema.optional(),
  validations: z
    .object({
      isRequired: z.boolean().optional()
    })
    .optional()
});
